import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import {
  ISlideshowDefinition,
  ISlideshowMapperProps,
  ISlideshowCarmiProps,
} from '../../types';

export const props = withCompInfo<
  ISlideshowMapperProps,
  ISlideshowDefinition,
  ISlideshowCarmiProps
>()(['compProps'], ({ compProps }, carmiData) => ({
  ...carmiData,
  ...compProps,
  currentIndex: 0,
  showNavigationButtons: true,
}));

export const css = withCompInfo()(
  ['styleProperties'],
  ({ styleProperties }) => {
    const { showNavigationButtons } = styleProperties;
    return {
      '--navButtonVisibility': showNavigationButtons ? 'visible' : 'hidden',
    };
  },
);

export default createComponentMapperModel({ props, css });
